import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';

import { enter } from 'src/app/resources/animations';
import { Log } from 'src/app/utils/log';
import { RootState } from 'src/app/reducers';
import { dispatchInfoMessage } from 'src/app/actions/core.actions';
import { deleteBookmarkProblemList, initializeDeleteBookmarkProblemListState } from 'src/app/actions/bookmark-problem-list.actions';
import { getDeleteBookmarkProblemListResult } from 'src/app/selectors/bookmark-problem-list.selectors';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DeleteBookmarkProblemListDialogData {
  id: string;
  listName: string;
}

@Component({
  selector: 'app-delete-bookmark-problem-list-dialog',
  templateUrl: './delete-bookmark-problem-list-dialog.component.html',
  styleUrls: ['./delete-bookmark-problem-list-dialog.component.scss'],
  animations: [enter]
})
export class DeleteBookmarkProblemListDialogComponent implements OnInit, OnDestroy {
  dialogTitle: string;
  bookmarkProblemListDeleting = false;
  errorMessage = '';
  private LOG_SOURCE = this.constructor.name;

  constructor(
    private store: Store<RootState>,
    private dialogRef: MatDialogRef<DeleteBookmarkProblemListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteBookmarkProblemListDialogData
  ) {}

  ngOnInit() {
    this.dialogTitle = 'お気に入りリストの削除';
  }

  ngOnDestroy() {
    this.store.dispatch(initializeDeleteBookmarkProblemListState());
  }

  deleteBookmarkProblemList() {
    if (!this.data.id) {
      Log.warn(this.LOG_SOURCE, `dialog.data(お気に入りリストのid)が設定されていません: `, this.data.id);
      return;
    }

    Log.debug(this.LOG_SOURCE, 'お気に入りリストを削除します');
    this.bookmarkProblemListDeleting = true;
    this.errorMessage = '';

    const request = {
      id: this.data.id
    };
    this.store.dispatch(deleteBookmarkProblemList(request));

    this.store
      .select(getDeleteBookmarkProblemListResult)
      .pipe(
        filter(it => it != null),
        take(1)
      )
      .subscribe(result => {
        this.store.dispatch(initializeDeleteBookmarkProblemListState());
        Log.debug(this.LOG_SOURCE, `お気に入りリストの削除結果: `, result);
        if (result.success) {
          this.bookmarkProblemListDeleting = false;

          const message = `${this.data.listName} を削除しました`;
          this.dialogRef.close(true);
          this.store.dispatch(
            dispatchInfoMessage({
              message
            })
          );
          return;
        }

        this.bookmarkProblemListDeleting = false;
        Log.warn(this.LOG_SOURCE, `お気に入りリストの削除エラー: err.code: ${result.error ? result.error.code : 'none'}`, result.error);
        this.errorMessage = result.error ? `[${result.error.code}] ${result.error.message}` : 'エラーが発生しました';
      });
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
